export const defaultValue = {
  gender: "male",
  age: 30,
  income: 40000,
  outcome: 30000,
  debt: 1000000,
  adaptPeriod: 5,
  inflaRate: 0.9,
};
